<script setup>
import { onMounted, ref } from 'vue'
import DataLayer from '@services/data-layer/index'
import BfhsTile from '@components/bfhs/bfhs-tile'

const bfh = ref(null)
const hasLoaded = ref(false)

onMounted(() => {
    DataLayer.bfhs.getAll({}).then(response => {
        bfh.value = response.body[0]
        hasLoaded.value = true
    })
})
</script>

<template>
    <div v-if="hasLoaded && bfh">
        <div class="bfh-section">
            <BaseSection>
                <BfhsTile :bfh="bfh"/>
            </BaseSection>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

$section-gap-tablet: 58px;
$section-gap-desktop: 72px;

.bfh-section {
    margin-top: 0;
}

@include tablet {
    .bfh-section {
        margin-top: $section-gap-tablet;
    }
}

@include desktop {
    .bfh-section {
        margin-top: $section-gap-desktop;
    }
}
</style>
